import { Theme, css } from '@emotion/react';

const commonButton = ({ colors, spacing }: Theme, isMenuOpen: boolean) => [
  css`
    // This margin-left spec assumes that DesktopHeaderReservationTypeSelectior
    // is entirely responsible for managing the space from the item in the
    // left header.
    margin-left: ${spacing(3.5)}px;
    // for these ghost buttons, the hpad as derived in buttonCssDefs:buttonDimensionsFromSize is weirdly large, we trim it down
    padding: 0 ${spacing(3)}px;
  `,
  // override the background style if it is open right now; this simulates the most important
  // part of the active style here.
  isMenuOpen &&
    css`
      background-color: ${colors.bgLight};
    `,
];

export const bookReservationButton = (theme: Theme, isMenuOpen: boolean, hide: boolean) =>
  !hide
    ? css`
        display: none;
        ${theme.breakpoints.up('md')} {
          display: flex;
          ${commonButton(theme, isMenuOpen)};
        }
      `
    : css`
        display: none;
      `;

export const shortReservationButton = (theme: Theme, isMenuOpen: boolean) => css`
  ${commonButton(theme, isMenuOpen)};
  ${theme.breakpoints.up('md')} {
    display: none;
  }
`;

export const popupContent = ({ spacing }: Theme) => css`
  padding: ${spacing(4)}px 0;
`;
